import { Button, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Edizione } from "../../types"
import EdizioneForm from "./EdizioneForm"
import { useNavigate } from "react-router-dom"
import { useEdizioneCreate } from "../../hooks/edizioni"
import { Formik } from "formik"
import { initialValuesEdizione, validationSchemaEdizione } from "./EdizioneCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function EdizioneCreate() {
  const createEdizione = useEdizioneCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Edizioni", href: "/edizioni/edizioni" }, { label: "Creazione Edizione" }])

  const initialValues = useMemo(() => initialValuesEdizione(), [])
  const validationSchema = useMemo(() => validationSchemaEdizione(true), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova edizione</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createEdizione.mutateAsync(values as Edizione).then((edizione) => {
                navigate(`/edizioni/edizioni/${edizione.id}/dettaglio`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <EdizioneForm />
                </Container>
                <BottomFormFixed url="/edizioni/edizioni" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
